import React from 'react';
import styles from './EmptyState.module.scss';

const EmptyState = ({ icon, title, description, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {icon && <div className={styles.iconWrapper}>{icon}</div>}
        <div className={styles.textWrapper}>
          {title && <h3 className={styles.title}>{title}</h3>}
          {description && <p className={styles.description}>{description}</p>}
        </div>
        {children && <div className={styles.children}>{children}</div>}
      </div>
    </div>
  );
};

export default EmptyState;
